<template>
  <div class="linkedin--content">
    <div
      class="
        linkedin--wrapper
        py-24
        2xl:w-2/5
        xl:w-3/5
        md:w-4/5
        w-5/6
        mr-auto
        ml-auto
      "
    >
      <div class="top--head text-center">
        <generic-header :content="getHeaderContent" />
      </div>
      <div class="linkedin--message--wrapper md:mt-30 mt-20">
        <div class="message--content text-lg text-gray-700 leading-relaxed">
          <p class="mb-6">
            I used to be on LinkedIn but around a few months back I came just
            realised that it's not what it seems like.
          </p>
          <p class="mb-6">
            Like any other social media, it's just filled with people sharing
            their achievements even though in reality, they're just doing simple
            certifications and posting for karma farming. I found out that that
            was affecting my productivity and decided to deactivate my account.
          </p>
          <p class="mb-6">
            I'm always open to discussing new opportunities, collaborations, and
            ideas in software development. Feel free to reach out if you'd like
            to connect or if you have any questions about my projects.
          </p>
          <p class="mb-6">Looking forward to connecting with you!</p>
        </div>
        <div class="signature md:mt-16 mt-8 text-gray-600">
          <p class="mt-2 font-semibold">~ Deepjyoti Barman</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GenericHeader from "./GenericHeader.vue";

export default {
  name: "LinkedInContent",
  components: { GenericHeader },
  computed: {
    getHeaderContent() {
      return {
        heading: "Unfortunately, I'm not on LinkedIn",
      };
    },
  },
};
</script>
